import { toastService, ToastItem } from '../../services/toast';

export class RcToastStack extends HTMLElement {
  private toasts: ToastItem[] = [];
  private unsubscribe: (() => void) | null = null;

  connectedCallback(): void {
    this.unsubscribe = toastService.subscribe((toasts) => {
      this.toasts = toasts;
      this.render();
    });
    this.render();
  }

  disconnectedCallback(): void {
    this.unsubscribe?.();
    this.unsubscribe = null;
  }

  private render(): void {
    this.innerHTML = `
      <div class="toast-stack" aria-live="polite" aria-atomic="true">
        ${this.toasts.map(toast => `
          <div class="toast toast-${toast.kind}" role="status" data-toast-id="${toast.id}">
            ${this.esc(toast.message)}
          </div>
        `).join('')}
      </div>
    `;
  }

  private esc(str: string): string {
    const el = document.createElement('span');
    el.textContent = str;
    return el.innerHTML;
  }
}

customElements.define('rc-toast-stack', RcToastStack);

export function ensureToastStackMounted(): void {
  if (!document.body || document.querySelector('rc-toast-stack')) {
    return;
  }

  document.body.appendChild(document.createElement('rc-toast-stack'));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ensureToastStackMounted(), { once: true });
} else {
  ensureToastStackMounted();
}
